<template>
  <WorkFormDialog
    ref="workTabsFormDialog"
    :promise-based-api-request-handler-method="
      promiseBasedApiRequestHandlerMethod
    "
    :width="width"
    :height="height"
    :with-serverside-validation="withServersideValidation"
    :form-data="formData"
    :path-of-form-data-element="pathOfFormDataElement"
    :server-side-validation-path-type="serverSideValidationPathType"
    :validate-serverside-custom-object="validateServersideCustomObject"
    :always-use-uuid-to-validate="alwaysUseUuidToValidate"
    :no-simple-close="noSimpleClose"
    :content-class="`w-tabs-dialog ${contentClass}`"
    :fixed-height="fixedHeight"
  >
    <template #header>
      <w-tabs-picker
        :value="value"
        :tabs="internalTabs"
        :cols="$vuetify.breakpoint.smAndDown ? 12 : 'auto'"
        :grow="false"
        :show-arrows="$vuetify.breakpoint.smAndDown"
        @input="emitTabSelection($event)"
        @currentComponent="(event) => (activeComponent = event)"
        @currentTab="(event) => (currentTab = event)"
      />
    </template>

    <template #content>
      <TabsStateManager
        :tabs="tabs"
        :active-tab="currentTab"
        @setTabstates="($event) => (tabStates = $event)"
      >
        <template
          v-for="(_, name) in tabContentSlots"
          :slot="name"
          slot-scope="slotData"
        >
          <slot
            :name="name"
            v-bind="slotData"
          />
        </template>
      </TabsStateManager>
    </template>
    <template #dialog-actions="{ triggerResolve, triggerReject, close }">
      <slot
        name="dialog-actions"
        :trigger-resolve="triggerResolve"
        :trigger-reject="triggerReject"
        :close="close"
        :current-tab="currentTab"
      />
    </template>

    <template #accept-action-text>
      <slot name="accept-action-text" />
    </template>

    <template #abort-action-text>
      <slot name="abort-action-text" />
    </template>
  </WorkFormDialog>
</template>

<script>
import { dynamicScopedSlots } from '@/utils/functional-component-utils';
import tabsMixin from '@/mixins/tabs-mixin';
import TabsStateManager from '@/components/view_root_components/components/TabsStateManager';
import WorkFormDialog from '@/components/base_components/dialog/form_dialogs/WorkFormDialog';
// import formUtils from "@/utils/form-utils";
// import axios from "axios";
// import cloneDeep from "lodash/cloneDeep";

export default {
  name: 'WorkTabsFormDialog',
  components: { WorkFormDialog, TabsStateManager },
  mixins: [tabsMixin],
  props: {
    value: { type: Number },
    tabs: { type: Array, default: () => [] },
    width: { type: String },
    height: { type: String },
    withServersideValidation: { type: Boolean, default: false },
    formData: { type: Object, default: () => {} },
    pathOfFormDataElement: { type: String, required: false },
    serverSideValidationPathType: { type: String, required: false },
    validateServersideCustomObject: { type: Function },
    alwaysUseUuidToValidate: { type: Boolean, default: false },
    promiseBasedApiRequestHandlerMethod: { type: Function, default: () => {} },
    noSimpleClose: { type: Boolean, default: false },
    contentClass: { type: String, default: '' },
    fixedHeight: { type: Boolean, default: false },
  },
  data() {
    return {
      activeComponent: null,
      currentTab: null,
      tabStates: {}
    };
  },
  computed: {
    internalTabs() {
      return this.tabs?.map(_tab => ({
        ..._tab,
        state: this.tabStates[_tab.id]
      }));
    },
    tabContentSlots() {
      return dynamicScopedSlots(this.$scopedSlots, 'tab_content');
    }
  },
  methods: {
    open(dataReference) {
      return this.$refs.workTabsFormDialog.open(dataReference);
    },
    emitTabSelection(event) {
      if (this.currentTab?.value != event) {
        this.$emit('input', event);
      }
    },
    handleError(error){
      this.$refs.workTabsFormDialog._handleError(error)
    }
  }
};
</script>
<style lang="scss">
.w-tabs-dialog .w-dialog-header {
  padding-bottom: 0 !important;
  .w-dialog-header__wrapper{
    justify-content: flex-start !important;
    .header-text-wrapper {
      flex-grow: 1 !important
    }
  }
}
</style>